module.exports = __webpack_public_path__ + "40d33c4a0e9bf31f84f743294791ed52.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/img1_3.jpg
// module id = 265
// module chunks = 0